export default "__VITE_ASSET__DSGTzHbb__"